import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from "@/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Registrar service worker para PWA
serviceWorkerRegistration.register({
  onSuccess: () => console.log('[PWA] App disponível offline.'),
  onUpdate: () => console.log('[PWA] Nova versão disponível. Recarregue a página.')
});
